import { WIDGET_FORM_INPUT_LINKS } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const LinksInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_LINKS,
  component: () => import("./links-input-widget.component").then((m) => m.LinksInputWidgetComponent)
};
